import w from 'warning';

export const warningMessage = (condition: any, format?: string | undefined, ...extra: any[]) => {
  if (process.env.BUILD === 'development') {
    w(condition, format, extra);
  }
};
